module.exports = __webpack_public_path__ + "static/media/2021sh.a16d37e3.jpg";